import { inject, observer } from 'mobx-react'
import * as React from 'react'
import Helmet from 'react-helmet'
import Module, { IModuleDataResponse } from '../../components/Module'

interface IDeeperProps {
  data: IModuleDataResponse
}

class Deeper extends React.PureComponent<IDeeperProps> {
  public render() {
    const { data } = this.props

    return (
      <div className="theme--green">
        <Helmet title="Deeper Talk" />
        <Module data={data} />
      </div>
    )
  }
}

export default Deeper

export const query = graphql`
  query DeeperFileQuery {
    allScriptsYaml(filter: { shortname: { eq: "deeper"} }) {
      edges {
        node {
          shortname
          details {
            title
            textIntro
            textSell
            textStart
          }
          sequence {
            title
            image
            icon
            source
            partner
            events {
              fileName
              length
              type
              extraTime
            }
          }
        }
      }
    }
    allFile(
      filter: {
        extension: { regex: "/webm|mp3|svg/" }
        relativeDirectory: { eq: "deeper" }
      }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          id
          name
          publicURL
          relativeDirectory
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/modules/Deeper.tsx